<template>
    <div id="editar-minuta-acuerdo">
    <v-form v-model="formularioValido" ref="editarMinutaAcuerdo">
        <v-card flat>
            <v-card-title class="secondary--text mb-4">
            Editar Acuerdo
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-subtitle>
            </v-card-subtitle>
            <v-card-text>
                <custom-text-field
                cols="12"
                class=""
                v-model="acuerdo.numero"
                label="Número"
                :rules="[mixReglas.requerido]"
                >
            </custom-text-field>
            <custom-text-area
                cols="12"
                v-model="acuerdo.descripcion"
                label="Descripción"
                rows="3"
                :rules="[mixReglas.requerido]">
            </custom-text-area>
            <v-row dense class="" style="">
                <v-col cols="12" md="6" class="">
                  <custom-date-picker
                  v-model="acuerdo.fechaLimite"
                  label="Fecha Limite"
                  :rules="[mixReglas.requerido]">
                  </custom-date-picker>
                </v-col>
              </v-row>
            <custom-text-field
                cols="12"
                class=""
                v-model="acuerdo.nombreReponsable"
                label="Responsables"
                :rules="[mixReglas.requerido]"
                >
            </custom-text-field>
                <!--
                <v-row>
                <v-col cols="12" md="6">
                      <custom-select
                      v-model="responsable"
                      label="Responsable"
                      :items="getParticipantesMinuta"
                      item-text="nombre"
                      return-object
                      :rules="[mixReglas.requerido]">
                      </custom-select>
                    </v-col>
                  </v-row>
                -->
              <v-row dense class="" style="">
                <v-col cols="12" md="6" class="">
                  <custom-date-picker
                  v-model="acuerdoFecha"
                  label="Fecha Cumplimiento"
                  >
                  </custom-date-picker>
                </v-col>
                <v-col cols="12" md="6">
                  <custom-select
                  v-model="acuerdoHora"
                  label="Hora Cumplimiento"
                  :items="horas"
                  >
                  </custom-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
        </v-card>
    </v-form>
    </div>
</template>
<script>
import CONTRATO_MINUTAS_PARTICIPANTES from '@/graphql/querys/administracion/minutas/contratoMinutasParticipantes.gql';
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import mixAcuerdos from './mixAcuerdos';

export default {
  name: 'EditarMinutaAcuerdo',
  mixins: [mixAcuerdos],
  props: {
    minutaAcuerdoEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      horas: this.getHorasList(),
      acuerdoFecha: '',
      acuerdoHora: '',
      /*
      responsable: {
        nombre: this.minutaAcuerdoEditar.nombreReponsable,
        puesto: this.minutaAcuerdoEditar.puestoResponsable,
      },
      */
      acuerdo: {
        numero: this.minutaAcuerdoEditar.numero,
        descripcion: this.minutaAcuerdoEditar.descripcion,
        fechaLimite: this.minutaAcuerdoEditar.fechaLimite,
        nombreReponsable: this.minutaAcuerdoEditar.nombreReponsable,
        puestoResponsable: this.minutaAcuerdoEditar.puestoResponsable,
        fechaHoraCumplimiento: '',

      },
    };
  },
  components: {
    CustomButton,
    CustomDatePicker,
    CustomTextArea,
    CustomTextField,
    CustomSelect,
  },
  apollo: {
    contratoMinutasParticipantes: {
      query: CONTRATO_MINUTAS_PARTICIPANTES,
      variables() {
        return {
          idMinuta: this.minutaAcuerdoEditar.idMinuta,
        };
      },
    },
  },
  mounted() {
    if (this.minutaAcuerdoEditar.fechaHoraCumplimiento !== ''
      && this.minutaAcuerdoEditar.fechaHoraCumplimiento !== null) {
      this.acuerdoFecha = this.splitFechaHora()[0] || '';
      this.acuerdoHora = this.splitFechaHora()[1].slice(0, 5) || '';
    }
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarMinutaAcuerdo.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    splitFechaHora() {
      if (this.minutaAcuerdoEditar.fechaHoraCumplimiento !== ''
      && this.minutaAcuerdoEditar.fechaHoraCumplimiento !== null) {
        const fechaHora = this.minutaAcuerdoEditar.fechaHoraCumplimiento.split('T');
        return fechaHora;
      }
      return [];
    },
    getFechaHora() {
      if (this.acuerdoFecha !== '') {
        if (this.acuerdoHora !== '') {
          const fechaHora = `${this.acuerdoFecha} ${this.acuerdoHora}:00.999+0000`;
          return fechaHora;
        }
        const fechaHora = `${this.acuerdoFecha} 08:00:00.999+0000`;
        return fechaHora;
      }
      return null;
    },
    getHorasList() {
      const horas = [];
      const horaInicio = 7;
      const horaFin = 19;
      for (let hora = horaInicio; hora <= horaFin; hora += 1) {
        horas.push(`${hora.toString().padStart(2, '0')}:00`);
        if (hora !== horaFin) {
          horas.push(`${hora.toString().padStart(2, '0')}:30`);
        }
      }
      return horas;
    },

    async guardar() {
      // this.acuerdo.nombreReponsable = this.responsable.nombre;
      // this.acuerdo.puestoResponsable = this.responsable.puesto;
      this.acuerdo.fechaHoraCumplimiento = this.getFechaHora();
      await this.mixEditarAcuerdo();
    },
  },
  computed: {
    getParticipantesMinuta() {
      if (!this.contratoMinutasParticipantes) return [];
      return this.contratoMinutasParticipantes;
    },
  },
};
</script>
